export default {
  setExportBatches: (state, exportBatches) => (state.exportBatches = exportBatches),
  setLoading: (state, loading) => (state.loading = loading)
}
